/*
 * @Author: jiangwei 
 * @Date: 2018-09-10
 */
import cryptoJs from 'crypto-js'

let des = {
  /* type : pdf epub swf */
  // ����
  encryptDes: function (message, key = '{ 11, 22, 33, 45, 54, 65, 79, 16 }', iv = '{ 10, 11, 16, 18, 20, 21, 41, 58 }') {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var ivHex = cryptoJs.enc.Utf8.parse(iv)
    var option = {
      iv: ivHex,
      mode: cryptoJs.mode.CBC,
      padding: cryptoJs.pad.Pkcs7
    }
    var encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
    return encrypted.ciphertext.toString()
  },
  // ����
  decryptDes: function (message, key = '{ 11, 22, 33, 45, 54, 65, 79, 16 }', iv = '{ 10, 11, 16, 18, 20, 21, 41, 58 }') {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var ivHex = cryptoJs.enc.Utf8.parse(iv)
    var decrypted = cryptoJs.DES.decrypt({
        ciphertext: cryptoJs.enc.Hex.parse(message)
      },
      keyHex, {
        iv: ivHex,
        mode: cryptoJs.mode.CBC,
        padding: cryptoJs.pad.Pkcs7
      }
    )
    return decrypted.toString(cryptoJs.enc.Utf8)
  },
  // �����ܴ�תbase64
  desToBase64: function (des) {
    var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var base64_rep = "";
    var bit_arr = 0;
    var bit_num = 0;
    for (var n = 0; n < des.length; ++n) {
      let ascv
      if (des[n] >= 'A' && des[n] <= 'Z') {
        ascv = des.charCodeAt(n) - 55;
      } else if (des[n] >= 'a' && des[n] <= 'z') {
        ascv = des.charCodeAt(n) - 87;
      } else {
        ascv = des.charCodeAt(n) - 48;
      }
      bit_arr = (bit_arr << 4) | ascv;
      bit_num += 4;
      if (bit_num >= 6) {
        bit_num -= 6;
        base64_rep += digits[bit_arr >>> bit_num];
        bit_arr &= ~(-1 << bit_num);
      }
    }
    if (bit_num > 0) {
      bit_arr <<= 6 - bit_num;
      base64_rep += digits[bit_arr];
    }
    var padding = base64_rep.length % 4;
    if (padding > 0) {
      for (var n = 0; n < 4 - padding; ++n) {
        base64_rep += "=";
      }
    }
    return base64_rep;
  }

}

export default des



// WEBPACK FOOTER //
// ./src/components/common/utils/des.js